module.exports = __webpack_public_path__ + "img/app_qr_all.f405f57b.jpg";